<template>
    <section class="recover-password-container">
      <FloatingHeader :title="'Recuperar Senha'" :sbtitle="'Defina uma nova senha'" :showHeader="true"
      :hideSearch="true" :routeToBack="'login'"></FloatingHeader>
        <h1>Olá, {{ userName }}. Digite sua nova senha.</h1>
        <div class="recover-password">
            <div class="recover-password-data">
                <label for="senha" class="required">Nova Senha: </label>
                <input type="password" id="new-password" name="new-password" placeholder="Nova senha" v-model="newPassword"/>
            </div>
            <div class="recover-password-data">
                <label for="confirm-new-password" class="required">Confirme a senha: </label>
                <input type="password" id="confirm-new-password" name="confirm-new-password" placeholder="Confirme a Senha" v-model="confirmNewPassword"/>
            </div>
            <div class="recover-password-button" v-if="!loading">
                <DefaultButton v-for="(but, bKey) in buttons" :key="bKey" :text="but.display" @defaultBtnClick="but.action && but.action()"></DefaultButton>
            </div>
            <div v-else-if="loading" class="loading">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
        </div>
        <ModalInfo @toLogin="toLogin"></ModalInfo>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { updatePasswordAfterRecover } from '@/assets/controllers/LoginController.js'
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import FloatingHeader from '@/components/FloatingHeader.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
export default {
  name: 'RecoverPasswordView',
  components: {
    FloatingHeader,
    DefaultButton,
    ModalInfo
  },
  data () {
    return {
      newPassword: '',
      confirmNewPassword: '',
      buttons: [
        {
          display: 'Atualizar',
          fill: true,
          action: this.updateNewPassword
        }
      ],
      fields: [
        {
          display: 'Senha atual',
          placeholder: 'Senha',
          type: 'password',
          required: true
        },
        {
          display: 'Nova senha',
          placeholder: 'Nova senha',
          type: 'password',
          required: true
        },
        {
          display: 'Confirmar nova senha',
          placeholder: 'Confirmar a senha',
          type: 'password',
          required: true
        }
      ],
      loading: false,
      userName: '',
      userToken: ''
    }
  },
  computed: {
    ...mapGetters(['recoverPasswordMenu', 'getRecoverPasswordData'])
  },
  methods: {
    ...mapActions(['changeRecoverPasswordMenuVisibility']),
    ...mapActions(['showModalInfo']),

    getId: function (display) {
      return display.replaceAll(' ', '').toLowerCase()
    },
    updateNewPassword: function () {
      this.passwordError = ''
      const isValidPassword = this.checkPassword()
      if (isValidPassword) {
        this.loading = true
        updatePasswordAfterRecover(this.userToken, this.newPassword).then((res) => {
          this.loading = false
          if (!res.error && res.data) {
            Util.showSuccessNotification({
              title: 'Senha atualizada com sucesso!',
              text: '',
              duration: 5000
            })

            this.$router.push('/')
          } else {
            Util.showErrorNotification({
              title: 'Erro ao atualizar a senha. Tente novamente.',
              text: ''
            })
          }
        })
      }
    },
    toLogin: function () {
      this.$router.push('/')
    },
    checkPassword: function () {
      if (!this.newPassword || !this.confirmNewPassword) {
        Util.showWarningNotification({
          title: 'Preencha todos os campos.',
          text: ''
        })
        return false
      }
      if (this.newPassword !== this.confirmNewPassword) {
        Util.showWarningNotification({
          title: 'As senhas não conferem.',
          text: ''
        })
        return false
      }
      return true
    }
  },
  mounted () {
    this.userName = this.$route.query.n
    this.userToken = this.$route.query.t
  }
}
</script>

<style lang="less" scoped>
.recover-password-container {
    padding: 65px 20px 170px 20px;

    .recover-password {
        margin-top: 10%;
        .recover-password-data{
            margin-bottom: 30px;
            label {
                display: block;
                position: relative;
                margin-bottom: 15px;
                &.required:after{
                    content: '*';
                    color: red;
                    margin-left: 5px;
                }
            }
            input:not([type="checkbox"]) {
                width: calc(100% - 20px);
                padding: 15px 10px;
                font-size: 16px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                border-radius: 7px;
                margin-top: 10px;
            }
        }
        .error-password {
            text-align: center;
            color: red;
        }
        .recover-password-button {
          position: fixed;
          display: flex;
          justify-content: center;
          width: -webkit-fill-available;
          bottom: 0;
          left: 0;
          padding: 10px 0 40px 0;

          button {
            display: block;
            min-width: 80vw !important;
            height: 55px !important;
            margin: 5px !important;
            border: none;
            background: var(--primaryColor);
            color: white;
          }
        }
    }

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
        i {
            font-size: 40px;
            color: var(--primaryColor);
        }
    }
}
</style>
